import React from 'react';
import { useTranslation } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import { UserIdentityOrigin, UserProfileResponse } from 'api/minside';
import { UserData } from 'components/profile/UserData';
import AAData from 'components/profile/AAData';
import KrrInfo from 'components/profile/KrrInfo';
// import AltinnRoles from 'components/profile/AltinnRoles';
import { useMsal } from 'auth/MsalContext';
import { Button } from 'common.ui';


export type IProps = {
  user: UserProfileResponse;
  onDeletePhone?: () => void;
  onNameChange?: () => void;
};

function ExternalUserInfo({ user, onDeletePhone, onNameChange }: IProps) {
  const { resetPassword, changeSigninEmail, editPhoneNumber } = useMsal();
  const { t } = useTranslation('pages');

  return (
    <Container fluid>
      <UserData user={user} onDeletePhone={onDeletePhone} onChangeName={onNameChange} />

      {/* only local account B2C users can change their password (through B2C), while other users must use their IdP. */}
      {user.identityOrigin === UserIdentityOrigin.Local && (
        <div className='profile-actions'>
          <Button
            id='btnChangePassword'
            text={t('externalUserInfo.changePasswordButtonText')}
            onClick={() => resetPassword()}
          />
          <Button
            id='btnChangeSigninEmail'
            text={t('externalUserInfo.changeSigninEmailButtonText')}
            onClick={() => changeSigninEmail()}
          />
          <Button
            id='btnEditPhoneNumber'
            text={t(
              user.mfaPhoneNumber
                ? 'externalUserInfo.editPhoneNumberButtonText'
                : 'externalUserInfo.addPhoneNumberButtonText'
            )}
            onClick={() => editPhoneNumber()}
          />
        </div>
      )}

      {user.isValidated && (
        <>
          {user.userKrrInfo && <KrrInfo user={user.userKrrInfo} />}
          <AAData user={user} />
        </>
      )}

      {/* {user.altinnRoles && user.altinnRoles.length > 0 && <AltinnRoles roles={user.altinnRoles ?? []} />} */}
    </Container>
  );
}

export default ExternalUserInfo;
